module.exports = __webpack_public_path__ + "img/food8.07476135.jpeg";